import React, { Component } from 'react';
import { global } from 'config';

export default class Anchor extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (<div>
            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                margin: '50px 0 20px',
                fontFamily: '宋体',
                color: '#000'
            }}>主播服务协议</h3>
            <div style={{
                marginBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000'
            }}>
                &nbsp;&nbsp;杭州叽里咕噜文化传播有限公司通过呼呼收音机平台（以下简称“呼呼收音机”），向创作者提供数据存储、管理、发布作品、分享的信息存储空间服务。创作者将按照国家法律法规、<a style={{ color: '#1890ff' }} href={global.href + "simple/user"} target="_blank" rel="noopener noreferrer">《用户协议》</a>及其他平台规则文件，通过呼呼收音机平台上传、发布图片、视听等作品，或者通过呼呼收音机平台向用户提供其他内容服务。<br />
                &nbsp;&nbsp;双方在提供和使用呼呼收音机信息存储空间服务期间，将遵守如下条款：<br />
                1.	创作者自愿使用呼呼收音机信息存储空间服务，所有通过创作者账户上传、发布作品均为创作者自身行为与呼呼收音机无关。<br />
                2.	创作者上传、发布作品均由创作者或者获得授权的第三方制作，包括音频、视频、动画片、背景音乐、歌曲、内容均由创作者自行提供。创作者承诺并保证对上传、发布的作品享有著作权及所有相关权利，不存在任何侵犯第三方合法权益（包括但不限于著作权、商标权、专利权、肖像权、人格权等）的情形。<br />
                3.	因创作者上传、发布作品引起的第三方投诉、维权的，由创作者自行解决并承担全部的法律责任，与呼呼收音机无关。若因作品侵权导致呼呼收音机承担赔偿责任的，创作者承诺赔偿呼呼收音机所遭受的所有损失，包括但不限于：赔偿款、诉讼费、律师费、公证费、差旅费等所有直接、间接损失。
            </div>
        </div>);
    }
}